// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11oEz","title":"styles_title__1qmUR"};